import { lazy } from "react";

const MobileNav = lazy(() => import('./mobile-nav'));
const TopNavbar = lazy(() => import('./top-navbar'));
const Sidebar = lazy(() => import('./sidebar/sidebar'));

export {
  MobileNav,
  TopNavbar,
  Sidebar,
};
